import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

import { OptionServiceDelivery } from '@app/forms/subscription/definition/interface/enum';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};
    const optionParticulier: any[] =
      entity?.parameters?.optionParticulier || [];

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        optionParticulier: [entity?.parameters?.optionParticulier || []],
        additionalPropertyOption: [
          optionParticulier.includes(
            OptionServiceDelivery.ADDITIONAL_PROPERTY,
          ) || null,
        ],
        tnsAffiliationOption: [
          optionParticulier.includes(OptionServiceDelivery.TNS_AFFILIATION) ||
            null,
        ],
        additionalProperty: [entity?.parameters?.additionalProperty || null],
        additionalPropertyNumber: [
          entity?.parameters?.additionalPropertyNumber || 0,
        ],
        additionalPropertyTotal: [
          entity?.parameters?.additionalPropertyTotal || 60,
        ],
        customizedOptimization: [
          entity?.parameters?.customizedOptimization || null,
        ],
        optimizedOptimization: [
          entity?.parameters?.optimizedOptimization || 120,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }

  extract(): any[] {
    const formValue = _.cloneDeep(this.form?.value?.products);

    const extractedValues = formValue?.map(item => {
      const optionParticulier = this.extractOptionParticulier(item?.parameters);
      const updatedItem = this.removeUnusedFields(item?.parameters);

      return {
        ...item,
        parameters: {
          ...item.parameters,
          ...updatedItem,
          optionParticulier,
        },
      };
    });

    return extractedValues;
  }

  private extractOptionParticulier(item: any): string[] {
    const optionParticulier = [];

    if (
      item.additionalPropertyOption &&
      !optionParticulier.includes(OptionServiceDelivery.ADDITIONAL_PROPERTY)
    ) {
      optionParticulier.push(OptionServiceDelivery.ADDITIONAL_PROPERTY);
    }
    if (
      item.tnsAffiliationOption &&
      !optionParticulier.includes(OptionServiceDelivery.TNS_AFFILIATION)
    ) {
      optionParticulier.push(OptionServiceDelivery.TNS_AFFILIATION);
    }

    return Array.from(new Set(optionParticulier));
  }

  private removeUnusedFields(item: any): any {
    const fieldsToRemove = ['additionalPropertyOption', 'tnsAffiliationOption'];

    return _.omit(item, fieldsToRemove);
  }
}
